import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./Services.css";
import { Editor } from "primereact/editor";

function Services() {
  let emptyService = {
    id: null,
    title: "",
    description1: "",
    title2: "",
    description2: "",
    sortOrder: null,
  };
  const [Services, setServices] = useState(null);

  const [ServicesDialog, setServicesDialog] = useState(false);
  const [DeleteServiceDialog, setDeleteServiceDialog] = useState(false);
  const [DeleteServicesDialog, setDeleteServicesDialog] = useState(false);
  const [Service, setService] = useState(emptyService);
  const [selectedServices, setSelectedServices] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false); // ✅ Prevent duplicate API calls

  useEffect(() => {
    if (!isFetched.current) {
      getServices();
      isFetched.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const getServices = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Services"
      );

      if (response.data) {
        setServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching Services:", error);
    }
  };

  const openNew = () => {
    setService(emptyService);
    setSubmitted(false);
    setServicesDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setServicesDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteServiceDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteServicesDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      if (Service.title.trim()) {
        let _Services = [...Services];
        let _Service = { ...Service };

        if (Service.id) {
          const index = findIndexById(Service.id);

          let formData = new FormData();
          formData.append("id", Service.id); // 👈 Make sure to include ID
          formData.append("title", _Service.title);
          formData.append("description1", _Service.description1);
          formData.append("title2", _Service.title2);
          formData.append("description2", _Service.description2);
          formData.append("sortOrder", _Service.sortOrder);

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL + "api/Services/" + Service.id,
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _Services[index] = _Service;

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Service Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Service Not Updated",
              life: 3000,
            });
          }
        } else {
          _Service.id = createId();
          let formData = new FormData();
          formData.append("title", _Service.title);
          formData.append("description1", _Service.description1);
          formData.append("title2", _Service.title2);
          formData.append("description2", _Service.description2);
          formData.append("sortOrder", _Service.sortOrder);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Services",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _Services.push(response.data);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Service Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Service Not Added",
              life: 3000,
            });
          }
        }

        setServices(_Services);
        setServicesDialog(false);
        setService(emptyService);
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the service. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (Service) => {
    setService({ ...Service });
    setServicesDialog(true);
  };

  const confirmDeleteProduct = (Service) => {
    setService(Service);
    setDeleteServiceDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL + "api/Services/" + Service.id
      );

      setLoading(false);

      if (response.status === 204) {
        // ✅ Check response status instead of data
        let _Services = Services.filter((val) => val.id !== Service.id);
        setServices(_Services);
        setDeleteServiceDialog(false);
        setService(emptyService);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Service Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Service Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < Services.length; i++) {
      if (Services[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteServicesDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedServices.map((Service) => Service.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Services/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _Services = Services.filter((val) => !selectedServices.includes(val));
      setServices(_Services);
      setDeleteServicesDialog(false);
      setSelectedServices(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Services Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Services Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _Service = { ...Service };

    _Service[`${name}`] = val;

    setService(_Service);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Services</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedServices || !selectedServices.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="Service-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={Services}
              selection={selectedServices}
              onSelectionChange={(e) => setSelectedServices(e.value)}
              dataKey={(rowData) => `services-${rowData.id}`}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="title"
                header="Title"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={ServicesDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Service Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="title" className="font-bold mb-1">
                Title :
              </label>
              <InputText
                id="title"
                value={Service.title}
                onChange={(e) => onInputChange(e, "title")}
                required
                className={classNames({
                  "p-invalid": submitted && !Service.title,
                })}
              />
              {submitted && !Service.title && (
                <small className="p-error">Title is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description1" className="font-bold mb-1">
                Description 1 :
              </label>
              <Editor
                id="description1"
                value={Service.description1}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description1"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !Service.description1,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="title2" className="font-bold mb-1">
                Title 2 :
              </label>
              <InputText
                id="title2"
                value={Service.title2}
                onChange={(e) => onInputChange(e, "title2")}
                className={classNames({
                  "p-invalid": submitted && !Service.title2,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="description2" className="font-bold mb-1">
                Description 2 :
              </label>
              <Editor
                id="description2"
                value={Service.description2}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description2"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !Service.description2,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={Service.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !Service.sortOrder,
                })}
              />
              {submitted && !Service.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteServiceDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {Service && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{Service.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteServicesDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {Service && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Services?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default Services;
